import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  props: {
    initOperateData: {
      type: Object,
      default: () => {}
    },
    tabVal: {
      type: String,
      default: '2'
    },
    initAudioMatrixEnable: {
      type: Boolean,
      default: false
    },
    initParticipantEnable: {
      type: Boolean,
      default: false
    },
    showSetting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      audioMatrixEnable: false,
      participantAudioMatrix: false,
      tableData: [],
      viewPositionInfo: {},
      matrixInfo: {},
      matrixInfoMuteMap: {},
      matrixInfoUnTalkMap: {},
      keyCodeList: {},
      pressFnInfo: {
        keyCode: 0,
        hasPress: false
      }
    };
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    returnParticipantSetting() {
      if (this.State.partyJoinInfo.owner) {
        return this.audioMatrixEnable && !this.State.audioMatrixFullScreen;
      } else {
        return false;
      }
    },
    returnShowTable() {
      if (this.State.partyJoinInfo.owner) {
        return this.audioMatrixEnable;
      } else {
        return this.audioMatrixEnable && this.State.partiAudioMatrixEnable;
      }
    }
  },
  watch: {
    initAudioMatrixEnable: {
      immediate: true,
      handler(val) {
        this.audioMatrixEnable = val;
      }
    },
    initParticipantEnable: {
      immediate: true,
      handler(val) {
        this.participantAudioMatrix = val;
      }
    },
    showSetting: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.State.partyJoinInfo.owner) {
            window.addEventListener('keyup', this.setPressFnDefault, false);
            window.addEventListener('keydown', this.listenHostKeyCode, false);
          } else {
            window.addEventListener('keydown', this.listenKeyCode, false);
          }
        }
      }
    }
  },
  async created() {
    // 至少有两个开关处于打开且其中一个包含pushToTalk时
    const enabledCount = [this.State.initPushToTalk, this.State.initAudioMatrixEnable, this.State.initIntercomEnable].filter(Boolean).length;
    if (enabledCount >= 2 && this.State.initAudioMatrixEnable) {
      this.changeVal(false, 'noMessage');
      this.audioMatrixEnable = false;
    }
    for (var i = 0; i < 11; i++) {
      this.keyCodeList[112 + i] = i + 1;
      if (i < 9) {
        this.keyCodeList[49 + i] = i + 1;
      }
    }
    this.keyCodeList[48] = 10;
    this.keyCodeList[189] = 11;
    this.keyCodeList[187] = 12;
    if (this.State.partyJoinInfo.owner) {
      window.addEventListener('keyup', this.setPressFnDefault, false);
      window.addEventListener('keydown', this.listenHostKeyCode, false);
    } else {
      window.addEventListener('keydown', this.listenKeyCode, false);
    }
    await this.getOnlineMember();
    this.getAllParticipant();
    Bus.$on('getAllParticipantInfo', async notNeedJudge => {
      const _this = this;
      if (_this.tabVal != '5' && !notNeedJudge) return;
      this.State.haveUnReadMessage = false;
      await this.getOnlineMember();
      this.getAllParticipant();
      Bus.$emit('changeLoading');
    });
    Bus.$on('audioOn', result => {
      const {
        rtilCode,
        muteRtilCode
      } = result;
      const array = this.matrixInfoMuteMap[rtilCode].filter(rtilCode => {
        return rtilCode != muteRtilCode;
      });
      this.$set(this.matrixInfoMuteMap, rtilCode, array);
    });
    Bus.$on('audioOff', result => {
      const {
        rtilCode,
        muteRtilCode
      } = result;
      if (this.matrixInfoMuteMap[rtilCode]) {
        this.matrixInfoMuteMap[rtilCode].push(muteRtilCode);
        this.$set(this.matrixInfoMuteMap, rtilCode, this.matrixInfoMuteMap[rtilCode]);
      } else {
        this.$set(this.matrixInfoMuteMap, rtilCode, [muteRtilCode]);
      }
    });
    Bus.$on('talkOn', result => {
      const {
        rtilCode,
        targetRtilCode
      } = result;
      if (this.matrixInfoUnTalkMap[rtilCode]) {
        const array = this.matrixInfoUnTalkMap[rtilCode].filter(rtilCode => {
          return rtilCode != targetRtilCode;
        });
        this.$set(this.matrixInfoUnTalkMap, rtilCode, array);
      }
    });
    Bus.$on('talkOff', result => {
      const {
        rtilCode,
        targetRtilCode
      } = result;
      if (this.matrixInfoUnTalkMap[rtilCode]) {
        this.matrixInfoUnTalkMap[rtilCode].push(targetRtilCode);
        this.$set(this.matrixInfoUnTalkMap, rtilCode, this.matrixInfoUnTalkMap[rtilCode]);
      } else {
        this.$set(this.matrixInfoUnTalkMap, rtilCode, [targetRtilCode]);
      }
    });
    Bus.$on('cancelListen', () => {
      if (this.State.partyJoinInfo.owner) {
        window.removeEventListener('keyup', this.setPressFnDefault, false);
        window.removeEventListener('keydown', this.listenHostKeyCode, false);
      } else {
        window.removeEventListener('keydown', this.listenKeyCode, false);
      }
    });
  },
  methods: {
    showMutexTip() {
      if (this.State.intercomEnable || this.State.pushTalkEnable) {
        this.$emit('mutexTip');
      }
    },
    listenKeyCode(e) {
      if (this.$route.name == 'partyParticipate' && !this.participantAudioMatrix) return;
      if (e.keyCode > 111 && e.keyCode < 124 || e.keyCode > 47 && e.keyCode < 60 || e.keyCode == 187 || e.keyCode == 189) {
        e.returnValue = false;
        const {
          rowVal,
          columnVal
        } = this.getInfoByKeyCode(e.keyCode);
        this.controlParticipant(rowVal, columnVal);
        e.preventDefault();
      }
    },
    getInfoByKeyCode(keyCode) {
      // 112-123 对应F1-F12
      // 48-53 187, 189 对应 1-0 外加 -, =
      let rowVal = {};
      let columnVal = {};
      if (keyCode > 111 && keyCode < 124) {
        rowVal = this.tableData[0];
        columnVal = this.tableData[this.keyCodeList[keyCode]];
      } else {
        rowVal = this.tableData[this.keyCodeList[keyCode]];
        columnVal = this.tableData[0];
      }
      return {
        rowVal,
        columnVal
      };
    },
    listenHostKeyCode(e) {
      if (this.$route.name == 'party' && !this.audioMatrixEnable) return;
      if (e.keyCode > 111 && e.keyCode < 124 || e.keyCode > 47 && e.keyCode < 60 || e.keyCode == 187 || e.keyCode == 189) {
        e.returnValue = false;
        // 记录已经按过 F1 ~ F12 中的一个
        if (e.keyCode > 111 && e.keyCode < 124) {
          this.pressFnInfo.hasPress = true;
          this.pressFnInfo.keyCode = e.keyCode;
        } else if (this.pressFnInfo.hasPress && (e.keyCode > 47 && e.keyCode < 60 || e.keyCode == 187 || e.keyCode == 189)) {
          const {
            rowVal,
            columnVal
          } = this.getHostInfoByKeyCode(e.keyCode);
          this.controlParticipant(rowVal, columnVal);
        }
        e.preventDefault();
      }
    },
    getHostInfoByKeyCode(keyCode) {
      // 112-123 对应F1-F12
      // 48-53 187, 189 对应 1-0 外加 -, =
      let rowVal = {};
      let columnVal = {};
      rowVal = this.tableData[this.keyCodeList[keyCode] - 1];
      columnVal = this.tableData[this.keyCodeList[this.pressFnInfo.keyCode] - 1];
      return {
        rowVal,
        columnVal
      };
    },
    setPressFnDefault(e) {
      if (e.keyCode > 111 && e.keyCode < 124) {
        this.pressFnInfo = {
          keyCode: 0,
          hasPress: false
        };
      }
    },
    changeVal(val, noMessage) {
      this.State.audioMatrixEnable = val;
      const params = {
        buttonType: 9,
        operationType: val ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.State.partyCode}`, params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (!noMessage) {
            this.$message.success(this.$t('setting.audioBackOperateSuccess'));
          }
        }
      });
    },
    changePartVal(val) {
      const params = {
        buttonType: 10,
        operationType: val ? 1 : 0
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.State.partyCode}`, params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.$message.success(this.$t('setting.audioBackOperateSuccess'));
        }
      });
    },
    async getOnlineMember() {
      await this.axios.get('/partyline-backend/commonParty/noLogin/getViewRtilCodes', {
        params: {
          partyCode: this.State.partyCode
        }
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.viewPositionInfo = res.data.result.viewPosition;
        }
      });
    },
    getAllParticipant() {
      this.axios.get(`/partyline-backend/audioMatrix/noLogin/getAll?partyCode=${this.State.partyCode}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          // 处理返回的 audioMatrix 信息
          res.data.result.forEach(item => {
            this.$set(this.matrixInfoMuteMap, item.rtilCode, item.muteRtilCodes);
            this.$set(this.matrixInfoUnTalkMap, item.rtilCode, item.unTalkRtilCodes);
          });
          const array = [];
          // 添加自己的 rtilCode
          array.unshift({
            name: this.State.globalNameInfo[this.State.partyJoinInfo.rtilCode],
            rtilCode: this.State.partyJoinInfo.rtilCode
          });
          this.State.allRtilCodeArray.forEach(rtilCode => {
            var _this$State$participa, _this$State$participa2, _this$State$participa3, _this$State$participa4;
            const sourceType = this.State.rtilCodeKeyTypeVal[rtilCode];
            // 只显示 web 和 T,R 的 VoIP source， 其他的暂时不支持
            if (rtilCode != this.State.partyJoinInfo.rtilCode && sourceType != 'T' && sourceType != 'R' || sourceType == 'T' && (_this$State$participa = this.State.participantInfo[rtilCode]) !== null && _this$State$participa !== void 0 && (_this$State$participa2 = _this$State$participa.originMemberId) !== null && _this$State$participa2 !== void 0 && _this$State$participa2.includes('voip') || sourceType == 'R' && (_this$State$participa3 = this.State.participantInfo[rtilCode]) !== null && _this$State$participa3 !== void 0 && (_this$State$participa4 = _this$State$participa3.originMemberId) !== null && _this$State$participa4 !== void 0 && _this$State$participa4.includes('voip')) {
              const obj = {};
              obj.name = this.State.globalNameInfo[rtilCode];
              obj.rtilCode = rtilCode;
              array.push(obj);
            }
          });
          this.tableData = array;
          const newArray = [];
          if (array.length < 4) {
            for (var i = 0; i < 4 - array.length; i++) {
              const obj = {};
              obj.name = '--';
              obj.rtilCode = i;
              newArray.push(obj);
            }
            this.tableData = this.tableData.concat(newArray);
          }
        }
      });
    },
    returnClass(rowVal, columnVal) {
      let _str = '';
      // 增加如果带有 deviceId 的一律 disabel
      if (rowVal.rtilCode == columnVal.rtilCode || rowVal.name == '--' || columnVal.name == '--' || this.State.deviceInfo[rowVal.rtilCode] && this.State.deviceInfo[rowVal.rtilCode].devicePlatform > 14 && this.State.deviceInfo[rowVal.rtilCode].devicePlatform < 10 || this.State.deviceInfo[columnVal.rtilCode] && this.State.deviceInfo[columnVal.rtilCode].devicePlatform > 14 && this.State.deviceInfo[columnVal.rtilCode].devicePlatform < 10) {
        _str = 'notAllowed';
        if (rowVal.rtilCode == columnVal.rtilCode) {
          _str += ' disabledColor';
        }
      }
      // 如果是与会者页面就只能控制自己和别人说话还是听，不能控制别人和别人之间的通话关系
      if (this.$route.name === 'partyParticipate' && columnVal.rtilCode != this.State.partyJoinInfo.rtilCode && rowVal.rtilCode != this.State.partyJoinInfo.rtilCode) {
        _str = 'notAllowed';
        if (rowVal.rtilCode == columnVal.rtilCode) {
          _str += ' disabledColor';
        }
      }
      return _str;
    },
    controlParticipant(rowVal, columnVal) {
      const canClick = this.judgeEnable(rowVal, columnVal);
      if (!canClick) return;
      // 根据最新需求需要分为 host 页面操作和与会者页面操作
      // 与会者页面操作又分为 talk to 谁和听谁两个接口
      if (this.State.partyJoinInfo.owner) {
        this.controllistenTo(rowVal, columnVal);
      } else {
        // 在判断与会者页面是 talk to 还是控制听谁
        if (rowVal.rtilCode == this.State.partyJoinInfo.rtilCode) {
          this.controlTalkTo(rowVal, columnVal);
        } else {
          this.controlMuteTo(rowVal, columnVal);
        }
      }
    },
    controllistenTo(rowVal, columnVal) {
      const currentVal = !this.showAvailable(rowVal, columnVal);
      const params = {
        partyCode: this.State.partyCode,
        rtilCode: columnVal.rtilCode,
        targetRtilCode: rowVal.rtilCode,
        enable: currentVal
      };
      this.axios.post('/partyline-backend/audioMatrix/listenTo', params).then(res => {});
    },
    controlTalkTo(rowVal, columnVal) {
      const currentVal = !this.showAvailable(rowVal, columnVal);
      const params = {
        partyCode: this.State.partyCode,
        rtilCode: rowVal.rtilCode,
        targetRtilCode: columnVal.rtilCode
      };
      this.axios.post(`/partyline-backend/audioMatrix/noLogin/${currentVal ? 'talkOn' : 'talkOff'}`, params).then(res => {});
    },
    controlMuteTo(rowVal, columnVal) {
      const currentVal = !this.showAvailable(rowVal, columnVal);
      const params = {
        partyCode: this.State.partyCode,
        rtilCode: columnVal.rtilCode,
        muteRtilCode: rowVal.rtilCode
      };
      this.axios.post(`/partyline-backend/audioMatrix/noLogin/${currentVal ? 'audioOn' : 'audioOff'}`, params).then(res => {});
    },
    // deviceType==='T'&&(devicePlatform<=14&&devicePlatform>=10)
    judgeEnable(rowVal, columnVal, notNeedJudgeDeviceType) {
      const _this = this;
      let flag = true;
      if (rowVal && columnVal && (rowVal.rtilCode == columnVal.rtilCode || rowVal.name == '--' || columnVal.name == '--')) flag = false;
      if (!rowVal || !columnVal) return false;
      if (_this.State.deviceInfo[rowVal.rtilCode] && _this.State.deviceInfo[rowVal.rtilCode].devicePlatform > 14 && _this.State.deviceInfo[rowVal.rtilCode].devicePlatform < 10 || _this.State.deviceInfo[columnVal.rtilCode] && _this.State.deviceInfo[columnVal.rtilCode].devicePlatform > 14 && _this.State.deviceInfo[columnVal.rtilCode].devicePlatform < 10) {
        flag = false;
      }
      // 如果是与会者页面就只能控制自己和别人不能控制别人和别人之间的通话关系
      if (_this.$route.name === 'partyParticipate' && columnVal.rtilCode != _this.State.partyJoinInfo.rtilCode && rowVal.rtilCode != _this.State.partyJoinInfo.rtilCode) {
        flag = false;
      }
      return flag;
    },
    showAvailable(rowVal, columnVal) {
      const _this = this;
      if (!_this.judgeEnable(rowVal, columnVal, 'notNeedJudgeDeviceType')) return false;
      let flag = true;
      // 根据最新需求是否显示勾选需要根据页面是 host 还是与会者来判断
      if (_this.State.partyJoinInfo.owner) {
        if (_this.matrixInfoUnTalkMap[rowVal.rtilCode] && _this.matrixInfoUnTalkMap[rowVal.rtilCode].includes(columnVal.rtilCode)) flag = false;
        if (_this.matrixInfoMuteMap[columnVal.rtilCode] && _this.matrixInfoMuteMap[columnVal.rtilCode].includes(rowVal.rtilCode)) flag = false;
      } else {
        // 与会者页面听别人的 UI 取决于自己是否 mute， 而其他列则取决于自己是否和他们 talk， 默认 talk
        if (columnVal.rtilCode == _this.State.partyJoinInfo.rtilCode && _this.matrixInfoMuteMap[columnVal.rtilCode] && _this.matrixInfoMuteMap[columnVal.rtilCode].includes(rowVal.rtilCode)) {
          flag = false;
        } else if (columnVal.rtilCode != _this.State.partyJoinInfo.rtilCode && _this.matrixInfoUnTalkMap[_this.State.partyJoinInfo.rtilCode] && _this.matrixInfoUnTalkMap[_this.State.partyJoinInfo.rtilCode].includes(columnVal.rtilCode)) {
          flag = false;
        }
      }
      return flag;
    },
    hostShowCode(scope) {
      let _str = '';
      if (scope.$index >= 0 && scope.$index <= 12) {
        if (scope.$index == 10) {
          _str = 0;
        } else if (scope.$index == 11) {
          _str = '-';
        } else if (scope.$index == 12) {
          _str = '=';
        } else {
          _str = scope.$index + 1;
        }
      }
      return _str;
    },
    showCode(scope, index) {
      let _str = '';
      if (this.State.partyJoinInfo.owner) {
        if (index >= 0 && index < 12) {
          _str = 'F' + (index + 1);
        }
      } else {
        if (scope.$index == 0 && index > 0 && index <= 12) {
          _str = 'F' + index;
        }
        if (index == 0 && scope.$index > 0 && scope.$index <= 12) {
          if (scope.$index == 10) {
            _str = 0;
          } else if (scope.$index == 11) {
            _str = '-';
          } else if (scope.$index == 12) {
            _str = '=';
          } else {
            _str = scope.$index;
          }
        }
      }
      return _str;
    }
  }
};